import { Box, Grid, Typography } from "@mui/material";
import GenerationCriteriaForm from "./templates/generation-criteria-form";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";

import "./style.css";
import { useRef, useState } from "react";
import DocumentGeneratorCTX from "./context";
import GeneratedDocument from "./templates/generated-document";
import { useReactToPrint } from "react-to-print";

const DocumentGenerator = () => {
  const [documentType, setDocumentType] = useState("");
  const [dataset, setDataset] = useState({});
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [pagesStartFrom, setPagesStartFrom] = useState(0);
  const [didSubmitGenerateBtn, setDidSubmitGenerateBtn] = useState(false);
  const generatedContentRef = useRef(null);
  const printGeneratedContent = useReactToPrint({
    content: () => {
      return generatedContentRef.current;
    },
  });

  return (
    <DocumentGeneratorCTX.Provider
      value={{
        documentType,
        dataset,
        didSubmitGenerateBtn,
        pagesStartFrom,
        printGeneratedContent,
        selectedYear,
        selectedMonth
      }}
    >
      <Grid container direction="row" padding={4} columnGap={4}>
        <Grid item xs={12} md={4} lg={4}>
          <GenerationCriteriaForm
            documentType={documentType}
            setDocumentType={setDocumentType}
            dataset={dataset}
            setDataset={setDataset}
            selectedYear={selectedYear}
            setSelectedYear={setSelectedYear}
            selectedMonth={selectedMonth}
            setSelectedMonth={setSelectedMonth}
            pagesStartFrom={pagesStartFrom}
            setPagesStartFrom={setPagesStartFrom}
            didSubmitGenerateBtn={didSubmitGenerateBtn}
            setDidSubmitGenerateBtn={setDidSubmitGenerateBtn}
          />
        </Grid>
        <Grid item xs>
          {!didSubmitGenerateBtn ? (
            <Box className="document-area-default-view">
              <CloudDownloadIcon width={150} sx={{ fontSize: 32 }} />
              <Typography>Document will be generate here.</Typography>
            </Box>
          ) : (
            <Box ref={generatedContentRef}>
              <GeneratedDocument />
            </Box>
          )}
        </Grid>
      </Grid>
    </DocumentGeneratorCTX.Provider>
  );
};

export default DocumentGenerator;
